// ============================================================
// toast.js — Notificaciones ligeras
// ============================================================
import { qs, el } from './utils.js';

const ICONS = {
  success: 'bi-check-circle-fill',
  error:   'bi-exclamation-circle-fill',
  warning: 'bi-exclamation-triangle-fill',
  info:    'bi-info-circle-fill',
};

export function toast({ message, type = 'info', duration = 3000 }) {
  let container = qs('#toastContainer');
  if (!container) {
    container = document.createElement('div');
    container.id = 'toastContainer';
    container.className = 'toast-container';
    document.body.appendChild(container);
  }

  const icon = ICONS[type] || ICONS.info;
  const item = el(`
    <div class="toast-item is-${type}" role="status">
      <i class="bi ${icon}"></i>
      <span></span>
    </div>
  `);
  // Insertamos el mensaje como text para evitar inyección
  item.querySelector('span').textContent = message;

  container.appendChild(item);

  setTimeout(() => {
    item.style.opacity = '0';
    item.style.transition = 'opacity 200ms';
    setTimeout(() => item.remove(), 220);
  }, duration);
}
